import clsx from 'clsx';
import React from 'react';

export const IsTypingBubble = () => {
  const className = clsx('flex w-full gap-1 items-center my-2 justify-start');

  return (
    <div className={className}>
      <div className="is-typing-bubble-animation" />
      <div className="is-typing-bubble-animation" />
      <div className="is-typing-bubble-animation" />
    </div>
  );
};
